import { ModalManager } from '@studyportals/modal';
import { BannerTypes, IDefinedSlot, IGoogleTag } from './models/banner/IGoogleTag';
import { StudySearch } from './StudySearch';

declare global {
	interface Window {
		ModalManager: ModalManager;
		rollbar?: typeof Rollbar;
		rollbarIgnore: (...args: any) => boolean;
		googletag: IGoogleTag;
		adSlots?: {
			[BannerTypes.TOP]: IDefinedSlot[];
			[BannerTypes.ADVANCED]: IDefinedSlot[];
			[BannerTypes.MOBILE_ADVANCED]: IDefinedSlot[];
		};
		Shared: {
			breakpoints(points: string[], callback?: () => void): boolean;
			debounce(callback: () => void, delay: number): () => void;
		};
		snowplow(source: string, payload: { terms: string[]; filters: object; totalResults: number }): void;
	}
}

const studySearch = new StudySearch();

export { studySearch as StudySearch };
